const TYPES = {
  SELLER: 'seller',
  AFFILIATE: 'affiliate',
  SUPER: 'super',
  SUPER_PARTNER: 'super_partner',
  BRAND: 'brand',
  UNKNOWN: '',
  LANDING: 'landing',
};

const WITH_PROFILE_HEADER = [
  TYPES.SELLER,
  TYPES.SUPER,
  TYPES.SUPER_PARTNER,
  TYPES.BRAND,
  TYPES.LANDING,
];

const ESHOPS_MOBILE_VARIATIONS = [
  TYPES.SELLER,
  TYPES.BRAND,
  TYPES.LANDING,
];

const WITH_POLYCARD = [
  TYPES.SELLER,
  TYPES.BRAND,
  TYPES.AFFILIATE,
  TYPES.LANDING,
];

const WITH_FREE_CAROUSEL = [
  TYPES.SELLER,
  TYPES.BRAND,
  TYPES.LANDING,
];

const WITH_POLYCARD_RECOS = [
  TYPES.SELLER,
  TYPES.BRAND,
  TYPES.LANDING,
];

const WITH_POLYCARD_GALLERY = [
  TYPES.SELLER,
  TYPES.BRAND,
  TYPES.LANDING,
];

const WITH_REDIRECT_HOME_BY_CCP = [
  TYPES.SELLER,
  TYPES.BRAND,
];

const WITHOUT_IMAGE_FLAG = [
  TYPES.SUPER,
  TYPES.SUPER_PARTNER,
];

module.exports = {
  TYPES,
  WITH_PROFILE_HEADER,
  ESHOPS_MOBILE_VARIATIONS,
  WITH_POLYCARD,
  WITH_FREE_CAROUSEL,
  WITH_POLYCARD_RECOS,
  WITH_POLYCARD_GALLERY,
  WITH_REDIRECT_HOME_BY_CCP,
  WITHOUT_IMAGE_FLAG,
};
